import Image from 'next/image'
import { Button } from '@repo/design-system-cf/components/button'
import { IconAddPhotoAlternate, IconClose } from '@repo/design-system-cf/components/icons'
import { Spinner } from '@repo/design-system-cf/components/spinner'
import { tw } from 'utils/classnames'

export function FileGallery({
  uploads,
  deletingIndex,
  onDelete,
  onAddMore,
}: {
  uploads: { url: string; uploading?: boolean; type: string }[]
  deletingIndex?: number | null
  onDelete: (index: number) => void
  onAddMore: () => void
}) {
  return (
    <div className="relative">
      <div className="grid gap-2 grid-flow-dense grid-cols-[repeat(auto-fit,minmax(75px,max-content))] overflow-x-auto whitespace-nowrap no-scrollbar">
        {uploads.map((upload, index) => (
          <div
            key={upload.url}
            className={tw(
              'group relative w-[75px] h-[75px] shrink-0 transition duration-200',
              deletingIndex === index && 'opacity-0 scale-75',
            )}
          >
            <div className="relative w-full h-full">
              {upload.uploading ? (
                <div className="absolute inset-0 rounded-[12px] w-full h-full bg-cf-grey-50 border border-[#1313151F] flex items-center justify-center flex-col gap-2">
                  <Spinner className="size-4 text-cf-purple-900" />
                  <p className="text-11 text-cf-purple-900 font-medium text-center whitespace-normal sm:block hidden">
                    {upload.type === 'image' ? 'Uploading photo…' : 'Processing video…'}
                  </p>
                </div>
              ) : (
                <Image
                  src={upload.url}
                  alt="uploaded"
                  width={75}
                  height={75}
                  className="object-cover rounded-[12px] w-full h-full"
                />
              )}
              <Button
                type="button"
                data-testid={`post-project-dialog-delete-image-button-${index}`}
                variant="tertiary"
                onClick={() => onDelete(index)}
                className="bg-[#E5DEF5] rounded-2 absolute top-1 right-1 flex items-center justify-center z-30 md:opacity-0 md:group-hover:opacity-100 transition-opacity"
                aria-label="delete image"
                size="small"
                iconRight={<IconClose className="text-cf-purple-900" />}
              />
            </div>
          </div>
        ))}

        {uploads.length < 10 ? (
          <div
            onClick={onAddMore}
            className="flex flex-col shrink-0 border border-dashed border-[#1313151F] justify-center items-center rounded-[12px] cursor-pointer hover:bg-cf-grey-100 bg-cf-grey-50 w-[75px] h-[75px]"
          >
            <IconAddPhotoAlternate className="text-cf-purple-900 !size-6 mb-2.5" />
            <p className="text-12 text-cf-purple-900 font-medium">Add</p>
          </div>
        ) : null}
      </div>
    </div>
  )
}
